import React from "react";
import { Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import Resources from "../../../../types/Resources";
import Attachment, { MalwareScanResultType } from "../../../../types/Attachment";

function AttachmentsModal(props: {
    resources: Resources;
    attachments: Attachment[];
    canManageAttachments: boolean;
    onDelete: (attachment: Attachment) => void;
    show: boolean;
    onHide: () => void;
}) {
    const listItems = props.attachments.map((attachment) => (
        <ListItem
            key={attachment.id}
            attachment={attachment}
            canManageAttachments={props.canManageAttachments}
            onDelete={props.onDelete}
            resources={props.resources}
        />
    ));

    return (
        <Modal show={props.show} onHide={props.onHide} size="lg">
            <Modal.Header closeButton>
                <h1 className="h5">{props.resources.get("AttachedFiles")}</h1>
            </Modal.Header>
            <Modal.Body>
                <ul className="m-0 p-0">{listItems}</ul>
            </Modal.Body>
        </Modal>
    );
}

export default AttachmentsModal;

function ListItem(props: {
    attachment: Attachment;
    canManageAttachments: boolean;
    onDelete: (attachment: Attachment) => void;
    resources: Resources;
}) {
    return (
        <li className="border rounded p-2 d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center">
                {props.attachment.isDownloadPreventionEnabled ? (
                    <ScanStatusIcon resources={props.resources} scanResult={props.attachment.scanResult} />
                ) : null}
                {props.attachment.canDownload ? (
                    <a href={`/api/attachment/${props.attachment.id}/download`}>{props.attachment.fileName}</a>
                ) : (
                    <span>{props.attachment.fileName}</span>
                )}
            </div>
            {props.canManageAttachments ? (
                <button className="btn btn-danger" onClick={() => props.onDelete(props.attachment)}>
                    <i className="fas fa-trash"></i>
                </button>
            ) : null}
        </li>
    );
}

const scanStatusIconClassName = {
    [MalwareScanResultType.Pending]: "fas fa-spinner fa-spin",
    [MalwareScanResultType.NoThreatsFound]: "fas fa-check text-success",
    [MalwareScanResultType.Malicious]: "fas fa-flag text-danger",
    [MalwareScanResultType.NotScanned]: "fas fa-spinner fa-spin",
} as const;

const scanStatusTooltipResourceKey = {
    [MalwareScanResultType.Pending]: "AttachmentScanPendingTooltip",
    [MalwareScanResultType.NoThreatsFound]: "AttachmentScanNoThreatsFoundTooltip",
    [MalwareScanResultType.Malicious]: "AttachmentScanMaliciousTooltip",
    [MalwareScanResultType.NotScanned]: "AttachmentScanNotScannedTooltip",
} as const;

function ScanStatusIcon(props: { resources: Resources; scanResult: MalwareScanResultType }) {
    const tooltip = <Tooltip>{props.resources.get(scanStatusTooltipResourceKey[props.scanResult])}</Tooltip>;

    return (
        <OverlayTrigger overlay={tooltip} placement="top" delay={{ show: 200, hide: 0 }}>
            <div className="d-inline-block">
                <i className={`${scanStatusIconClassName[props.scanResult]} me-2`}></i>
            </div>
        </OverlayTrigger>
    );
}
